import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AppLoading from '../../App/AppLayout/containers/AppLoading';

class Loading extends PureComponent {
	static propTypes = {
		transparent: PropTypes.bool
	};

	static defaultProps = {
		transparent: false
	};

	render() {
		const { transparent = false } = this.props;

		return <AppLoading show={true} transparent={transparent} />;
	}
}

export default Loading;
